import { render, staticRenderFns } from "./InvalidFormTitle.vue?vue&type=template&id=482b5f2a&scoped=true&"
import script from "./InvalidFormTitle.vue?vue&type=script&lang=js&"
export * from "./InvalidFormTitle.vue?vue&type=script&lang=js&"
import style0 from "./InvalidFormTitle.vue?vue&type=style&index=0&id=482b5f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b5f2a",
  null
  
)

export default component.exports